import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#3152E6",
      d: "M5.501 23.146a1.66 1.66 0 0 1-1.716.067 1.66 1.66 0 0 1-.873-1.464V9.63a3.68 3.68 0 0 1 3.69-3.672h13.427c2.038.001 3.69 1.645 3.692 3.672v8.02c-.006 2.024-1.657 3.662-3.692 3.663H8.852c-.324 0-.642.092-.913.269zM25.734 11.31v6.339a5.68 5.68 0 0 1-1.677 4.004 5.74 5.74 0 0 1-4.028 1.664H8.951l-.582.384v.001a3.684 3.684 0 0 0 3.601 2.953h10.38c.843 0 1.668.24 2.377.692l1.772 1.157c.52.33 1.176.356 1.72.067.538-.294.873-.856.872-1.467V14.969a3.683 3.683 0 0 0-3.357-3.66"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "liveChat"}) } }